<ng-container *ngIf="openInComponent">
  <a
    class="nameUnit"
    (click)="openPopOver()"
    [ae2Ga4Event]="'call_to_action'"
    [ga4Params]="{
      event_type: 'interaction',
      journey: 'reserva',
      section: 'menu',
      element_type: 'botao',
      element_label: 'reservar aulas'
    }"
  >
    reservar aulas
  </a>
</ng-container>
<ng-container *ngIf="!openInComponent">
  <a
    class="nameUnit"
    [ae2Ga4Event]="'call_to_action'"
    [ga4Params]="{
      event_type: 'interaction',
      journey: 'reserva',
      section: 'menu',
      element_type: 'botao',
      element_label: 'reservar aulas'
    }"
  >
    reservar aulas
  </a>
</ng-container>
